import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import Searchbar from './widgets/SearchBar';
import ContactList from '../../../pages/messages/subparts/ContactList';
import ConversationList from '../../../pages/messages/subparts/ConversationList';
import {useEyeconxStore} from '../../../../store/eyeconxStore';
import smsgatewayService from '../../../../services/smsgateway.service';
import {toast} from 'react-toastify';
import SubHeader from '../../../layout/components/SubHeader';
import ContactListSkeleton from './widgets/ContactListSkeleton';
import ConversationSkeleton from './widgets/ConversationSkeleton';
import ComposePatientModal from './widgets/ComposePatientModal';

const getContactDetails = (chatMessages) => {
    if (!Array.isArray(chatMessages) || chatMessages.length === 0) {
        return null;
    }

    return chatMessages.find((msg) => msg?.customerFirstName || msg?.customerLastName) || chatMessages[0];
};

const normalizeCustomerDob = (dob) => {
    if (!dob) {
        return null;
    }

    if (Array.isArray(dob) && dob.length >= 3) {
        const [year, month, day] = dob;
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    }

    return dob;
};

const buildSendMessagePayload = ({
    clinicId,
    clinicSms,
    customer,
    message,
    contactMessage,
    isConfirmationRequired,
}) => {
    const payload = {
        clinicId,
        business: clinicSms,
        customer,
        message,
        isConfirmationRequired,
    };

    if (contactMessage?.customerFirstName) {
        payload.customerFirstName = contactMessage.customerFirstName;
    }
    if (contactMessage?.customerLastName) {
        payload.customerLastName = contactMessage.customerLastName;
    }

    const customerDob = normalizeCustomerDob(contactMessage?.customerDob);
    if (customerDob) {
        payload.customerDob = customerDob;
    }

    return payload;
};


const SMSFeature = () => {
    const location = useLocation();
    const pendingCustomer = useRef(location.state?.customer);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchCriteria, setSearchCriteria] = useState('firstName');
    const [sortOrder, setSortOrder] = useState(location.state?.initialSort || 'desc');
    const [activeSearchString, setActiveSearchString] = useState('');
    //const [message, setMessage] = useState('');
    const [chat, setChat] = useState([])
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingMore, setLoadingMore] = useState(false)
    const clinicId = useEyeconxStore(state => state.user.clinicId)
    const clinicInfo = useEyeconxStore(state => state.clinicInfo)

    const [loadConversation, setLoadConversation] = useState(false)
    const isMounted = useRef(false); // ref to track if the component is mounted
    const [nextCursor, setNextCursor] = useState(null)
    const [hasNext, setHasNext] = useState(false)
    const [conversationDetails, setConversationDetails] = useState([])
    const [conversationDetailsLoading, setConversationDetailsLoading] = useState(false)
    const [isLegacyTwoWayText, setIsLegacyTwoWayText] = useState(false)
    const [showComposeModal, setShowComposeModal] = useState(false)
    useEffect(() => {
        // console.log("Function called ")

        if (!isMounted.current) {
            isMounted.current = true;
            getUserList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!clinicId) return;

        smsgatewayService.getClinicCustomize(clinicId)
            .then(res => {
                const legacySetting = (res.data || []).find(item => item.optionKey === 'isLegacyTwoWayText');
                setIsLegacyTwoWayText(legacySetting?.optionValue === '1');
            })
            .catch(() => {
                setIsLegacyTwoWayText(false);
            });
    }, [clinicId]);

    useEffect(() => {
        if (pendingCustomer.current) {
            handleUserSelect(pendingCustomer.current);
            pendingCustomer.current = null;
            window.history.replaceState({}, document.title);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getConversationDetails = () => {
        setConversationDetails(null)
        setConversationDetailsLoading(true)
        smsgatewayService.getConversationDetails(clinicId, selectedUser)
            .then(res => {
                setConversationDetails(res.data)
                // console.log("Conversation Details : ")
                // console.log(res.data)
                setConversationDetailsLoading(false)
            })
            .catch(err => {
                toast.error("Error getting Conversation Details");
                setConversationDetailsLoading(false)
            })
    }
    const getUserList = (cursor = null, size = 10, searchString = activeSearchString, sort = sortOrder) => {
        console.log("Get User List")
        console.log("Cursor:" + cursor + " Size: " + size + " search String " + searchString + " sort " + sort)

        // Set loading state based on whether it's initial load or load more
        if (cursor === null) {
            setLoading(true)
        } else {
            setLoadingMore(true)
        }

        smsgatewayService.getInbox(clinicId, searchCriteria, searchString, cursor, size, sort)
            .then(res => {
                console.log(res.data)
                // Append new users to existing list
                if (cursor === null) {
                    setUsers(res.data.data)
                } else {
                    setUsers((prevUser) => [...prevUser, ...res.data.data])
                }
                setNextCursor(res.data.nextCursor)
                setHasNext(res.data.hasNext)
                setLoading(false)
                setLoadingMore(false)
            })
            .catch(err => {
                toast.error("Error getting Users");
                setLoading(false)
                setLoadingMore(false)
            })
    }
    const handleConversation = (user, pageNo = 0, pageSize = 30) => {
        setLoadConversation(true)
        smsgatewayService.getConversation(clinicId, user, pageNo, pageSize)
            .then(res => {
                console.log(res.data)
                console.log("Sms Chat Data")
                setChat(res.data)
                setLoadConversation(false)
            })
            .catch(err => {
                toast.error("Error getting Conversation");
                setLoadConversation(false)
            })
    }
    const handleUserSelect = (user) => {
        handleConversation(user)
        setSelectedUser(user);

    };

    const handleSearchChange = (strSearch) => {
        setActiveSearchString(strSearch)
        setUsers([])
        setNextCursor(null)
        setHasNext(false)
        getUserList(null, 10, strSearch, sortOrder)
    };

    const handleSortChange = (newSort, searchString = activeSearchString) => {
        setSortOrder(newSort)
        setActiveSearchString(searchString)
        setUsers([])
        setNextCursor(null)
        setHasNext(false)
        getUserList(null, 10, searchString, newSort)
    };

    const handleSearchCriteriaChange = (e) => {
        setSearchCriteria(e.target.value);
    };

    const handleSendMessage = (message, isConfirmationRequired = false) => {
        if (message.trim() === '' || !selectedUser) return;

        const contactMessage = getContactDetails(chat);
        const customer = contactMessage?.customer || selectedUser;
        const sendNewMessage = buildSendMessagePayload({
            clinicId,
            clinicSms: clinicInfo.sms,
            customer,
            message,
            contactMessage,
            isConfirmationRequired,
        });

        smsgatewayService.sendMessage(clinicId, sendNewMessage)
            .then(res => {
                console.log(res.data)
                const now = new Date();
                const formattedDate = now.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                });
                const formattedTime = now.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                });
                const modifiedAt = `${formattedDate} ${formattedTime}`;

                const newMessage = {
                    "business": clinicInfo.sms,
                    "customer": selectedUser,
                    "message": res.data?.message ?? message,
                    "customerFirstName": contactMessage?.customerFirstName || '',
                    "customerLastName": contactMessage?.customerLastName || '',
                    "customerDob": contactMessage?.customerDob || '',
                    "messageType": "OUTGOING",
                    "status": "ACCEPTED",
                    "modifiedAt": modifiedAt
                }

                setChat(prevChat => [...prevChat, newMessage])
                setUsers([])
                setNextCursor(null)
                setHasNext(false)
                getUserList(null, 10, activeSearchString, sortOrder)
            })
            .catch(err => {
                toast.error("Error sending Message");
            })
    };

    const handleReset = () => {
        setSearchCriteria("firstName")
        setSearchTerm("")
        setActiveSearchString("")
        setUsers([])
        setNextCursor(null)
        setHasNext(false)
        getUserList(null, 10, "", sortOrder)
    }
    const handleLoadMore = () => {
        console.log("Load More with cursor: " + nextCursor)
        if (hasNext && !loadingMore) {
            getUserList(nextCursor, 10, activeSearchString, sortOrder)
        }
    }
    const handleRefresh = () => {
        setSelectedUser(null)
        setConversationDetails(null)
        setUsers([])
        setNextCursor(null)
        setHasNext(false)
        getUserList(null, 10, activeSearchString, sortOrder)
    }

    const handleDeleteConversation = () => {
        if (!selectedUser) return;

        smsgatewayService.deleteConversation(clinicId, selectedUser)
            .then(res => {
                toast.success("Conversation deleted successfully");
                // Reset and refresh
                handleRefresh();
            })
            .catch(err => {
                toast.error("Error deleting conversation");
            })
    }

    const handleComposePatientSelect = (patient) => {
        const phone = patient.phone;
        const stubChat = [{
            customer: phone,
            customerFirstName: patient.firstName,
            customerLastName: patient.lastName,
            customerDob: patient.dob,
        }];

        setShowComposeModal(false);
        setSelectedUser(phone);
        setChat(stubChat);
        setLoadConversation(true);

        smsgatewayService.getConversation(clinicId, phone, 0, 30)
            .then(res => {
                if (res.data && res.data.length > 0) {
                    setChat(res.data.map((msg) => ({
                        ...msg,
                        customerFirstName: msg.customerFirstName || patient.firstName,
                        customerLastName: msg.customerLastName || patient.lastName,
                        customerDob: msg.customerDob || patient.dob,
                    })));
                }
            })
            .catch(() => {
                setChat(stubChat);
            })
            .finally(() => {
                setLoadConversation(false);
            });
    };
    return (
        <>
            <SubHeader
                title="Messages"
                description="Communicate with patients using SMS"
                icon="bi-chat-left-text"
                iconClass="text-success"
                containerClass="container-fluid px-4"
            >
                <div className="d-flex align-items-center gap-2">
                    {isLegacyTwoWayText && (
                        <button
                            className='btn btn-light-primary btn-sm rounded-pill'
                            onClick={() => setShowComposeModal(true)}
                            title="Compose new message"
                        >
                            <i className="bi bi-pencil-square me-1"></i>
                            Compose
                        </button>
                    )}
                    <button
                        className='btn btn-light-primary btn-sm rounded-pill'
                        onClick={handleRefresh}
                        title="Refresh messages"
                    >
                        <i className="bi bi-arrow-clockwise me-1"></i>
                        Refresh
                    </button>
                </div>
            </SubHeader>
            <ComposePatientModal
                show={showComposeModal}
                onHide={() => setShowComposeModal(false)}
                clinicId={clinicId}
                onPatientSelect={handleComposePatientSelect}
            />
            <div className='container-fluid px-4 py-3'>
                <div className="row g-3">
                    {/* Left Sidebar - Contact List */}
                    <div className="col-12 col-lg-4 col-xl-4">
                        <div className="card shadow-sm border-0" style={{ height: 'calc(100vh - 200px)' }}>
                            <div className="card-body p-3 d-flex flex-column h-100" style={{ overflow: 'hidden' }}>
                                <Searchbar
                                    handleSearchChange={handleSearchChange}
                                    searchCriteria={searchCriteria}
                                    handleSearchCriteriaChange={handleSearchCriteriaChange}
                                    searchTerm={searchTerm}
                                    handleReset={handleReset}
                                    sortOrder={sortOrder}
                                    handleSortChange={handleSortChange}
                                />
                                {loading ? (
                                    <ContactListSkeleton />
                                ) : (
                                    <ContactList
                                        users={users}
                                        handleUserSelect={handleUserSelect}
                                        selectedUser={selectedUser}
                                        handleLoadMore={handleLoadMore}
                                        hasNext={hasNext}
                                        loadingMore={loadingMore}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right Panel - Conversation */}
                    <div className="col-12 col-lg-8 col-xl-8">
                        {selectedUser ? (
                            <>
                                {loadConversation ? (
                                    <ConversationSkeleton />
                                ) : (
                                    Array.isArray(chat) && chat.length > 0 && (
                                        <ConversationList
                                            smsData={chat}
                                            handleSendMessage={handleSendMessage}
                                            getConversationDetails={getConversationDetails}
                                            conversationDetails={conversationDetails}
                                            conversationDetailsLoading={conversationDetailsLoading}
                                            handleDeleteConversation={handleDeleteConversation}
                                        />
                                    )
                                )}
                            </>
                        ) : (
                            <div className="card shadow-sm border-0" style={{ height: 'calc(100vh - 200px)' }}>
                                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                    <div className="bg-light rounded-circle p-4 mb-4">
                                        <i className="bi bi-chat-square-text text-primary" style={{fontSize: '3rem'}}></i>
                                    </div>
                                    <h5 className="text-dark fw-semibold mb-2">Select a conversation</h5>
                                    <p className="text-muted mb-0">Choose a contact from the list to start messaging</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SMSFeature;
